/* eslint-disable no-alert */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  // CircularProgress,
  Divider,
  MenuItem,
  Select,
  // Tooltip,
  Typography,
} from "@mui/material";

// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
import { useStateContext } from "contexts/ContextProvider";
import feedService from "services/feedback-service";
import dayjs from "dayjs";
import UnitSelect from "components/Textfields/UnitSelect";
import SelectDesignation from "components/Textfields/SelectDesignation";
import SelectLevel from "components/Textfields/SelectLevel";
import AdminTable from "./AdminTable";
import DatePickerComponent from "../../../components/Textfields/DatePicker";
// import StatBox from "../../../components/Statbox";

export default function Feedbacks() {
  const { auth } = useStateContext();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [open, setOpen] = useState(false);
  const [reportType, setReportType] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [availableYears, setAvailableYears] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);

  const handleGetAll = () => {
    setLoading(true);
    setError("");

    // Office IDs for the specified offices (numeric)
    const officeId1 = 12; // Replace with actual ID for "School Management Monitoring and Evaluation"
    const officeId2 = 16; // Replace with actual ID for "Planning and Research Section"

    feedService
      .getFilteredFeedbacksByDate({
        startDate: start ? dayjs(start).format("YYYY-MM-DD") : null,
        endDate: end ? dayjs(end).format("YYYY-MM-DD") : null,
        officeId:
          !auth.officeId ||
          !auth.officeName ||
          auth.officeId === officeId1 ||
          auth.officeId === officeId2
            ? null
            : auth.officeId,
      })
      .then((response) => {
        // If the user belongs to specific offices, filter response data by officeName
        let filteredData =
          auth.officeId === officeId1 || auth.officeId === officeId2
            ? response.filter((item) =>
                [
                  "School Governance and Operations Division (SGOD) - School Management Monitoring and Evaluation",
                  "School Governance and Operations Division (SGOD) - Planning and Research Section",
                ].includes(item.officeName)
              )
            : response;

        // If user is an admin, filter further to only include designationId === 1
        if (auth.role === "admin") {
          filteredData = filteredData.filter(
            (item) => item.designationId === 1
          );
        }

        const newData = filteredData
          .map((item) => ({
            ...item,
            created_at: dayjs(item.created_at),
            updated_at: dayjs(item.updated_at),
          }))
          .sort((a, b) => b.created_at - a.created_at);

        setData(newData);

        const years = [
          ...new Set(newData.map((item) => item.created_at.year())),
        ].sort((a, b) => b - a);

        setAvailableYears(years);
      })
      .catch((err) => {
        setError(err?.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCustomReport = async (
    startDate,
    endDate,
    designationId,
    officeId
  ) => {
    setLoading(true);
    setError("");

    // Ensure dates are properly formatted
    const formattedStartDate = startDate
      ? dayjs(startDate).format("YYYY-MM-DD")
      : null;
    const formattedEndDate = endDate
      ? dayjs(endDate).format("YYYY-MM-DD")
      : null;

    const filenameStartDate = startDate
      ? dayjs(startDate).format("MMM-DD")
      : null;
    const filenameEndDate = endDate ? dayjs(endDate).format("MMM-DD") : null;
    const year = endDate
      ? dayjs(endDate).format("YYYY")
      : dayjs().format("YYYY");

    try {
      const requestPayload = {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        designationId,
        officeId: auth.role === "admin" ? officeId : auth.officeId,
      };

      const response = await feedService.exportFilteredFeedbacks(
        requestPayload
      );

      if (!response || !response.data) {
        throw new Error("No data received from server");
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      // Extract filename from Content-Disposition header (if available)
      const disposition = response.headers["content-disposition"];
      let filename = `CSM_Custom_Report_${filenameStartDate}_to_${filenameEndDate}.xlsx`;

      if (disposition) {
        filename = disposition.split("filename=")[1].replace(/"/g, "");
      }

      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error exporting custom report:", error);
      alert(`Failed to export custom report: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleQuarterlyReport = async (year, designationId, officeId) => {
    setLoading(true);
    setError("");

    const payload = {
      year,
      reportType: "Quarterly",
      designationId,
      officeId: auth.role === "admin" ? officeId : auth.officeId,
    };

    console.log("📤 Sending Quarterly Report Request with Payload:", payload);

    try {
      const response = await feedService.exportQuarterlyFeedbacks({
        year,
        reportType: "Quarterly",
        designationId,
        officeId: auth.role === "admin" ? officeId : auth.officeId, // Use selectedOffice
      });

      const datestamp = year;

      // Create a blob from the response data
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      // Create a temporary URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a link element and click it to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `CSM_Report_${datestamp}.xlsx`);
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMonthlyReport = async () => {
    try {
      const data = {
        year: selectedYear,
        designationId: selectedLocation,
        officeId: auth.role === "admin" ? selectedOffice : auth.officeId,
        ...(selectedMonth && { month: selectedMonth }), // Only include 'month' if selected
      };

      // console.log("Sending request to backend:", data);

      const response = await feedService.exportMonthlyFeedbacks(data);
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `CSM_Monthly_Report_${data.year}${
        selectedMonth ? `_Month_${selectedMonth}` : ""
      }.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting monthly report:", error);
      alert("Failed to export monthly report.");
    }
  };

  const handleYearlyReport = async (year, designationId, officeId) => {
    setLoading(true);
    setError("");

    try {
      const requestPayload = {
        year,
        designationId,
        officeId: auth.role === "admin" ? officeId : auth.officeId,
      };

      const response = await feedService.exportAnnualFeedbacks(requestPayload);

      if (!response || !response.data) {
        throw new Error("No data received from server");
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `CSM_Yearly_Report_${year}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting yearly report:", error);
      alert(`Failed to export yearly report: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleResetDateFilter = () => {
    setStart(null);
    setEnd(null);
  };

  useEffect(() => {
    handleGetAll();
  }, [start, end]);

  return (
    <Box
      sx={{
        p: "20px",
        backgroundColor: "#1c1948",
      }}
    >
      <Box>
        <Typography
          sx={{
            textAlign: "left",
            fontSize: "20px",
            fontWeight: "bold",
            color: "white",
          }}
        >
          {auth?.role === "admin"
            ? "Welcome to the SDOIC-CSM Data Management System!"
            : "Welcome to the SDOIC-CSM Data and Report Generation System!"}
        </Typography>
        <Typography
          sx={{
            textAlign: "left",
            fontSize: "15px",

            color: "white",
            mt: 2,
            mb: 2,
          }}
        >
          {auth?.role === "admin" ? "Administrator" : auth?.officeName}
        </Typography>
      </Box>
      <Box
        borderRadius="10px"
        boxShadow="3px 2px 15px 3px rgba(100, 100, 100, 0.8)"
        p="1rem"
        sx={{ backgroundColor: "rgba(240, 240, 240, 1)" }}
      >
        <Divider>
          <Typography
            sx={{
              textTransform: "uppercase",
              fontSize: "25px",
              mt: 5,
              fontWeight: "bold",
            }}
          >
            CUSTOMER SATISFACTION DATA
          </Typography>
        </Divider>

        <Box
          sx={{
            width: "98%",
            mt: 5,
            mb: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <DatePickerComponent
            label="Start"
            value={start}
            onChange={(newValue) => setStart(dayjs(newValue))}
          />
          <Typography sx={{ mx: 2, fontFamily: "Poppins" }}> To </Typography>
          <DatePickerComponent
            label="End"
            value={end}
            onChange={(newValue) => setEnd(dayjs(newValue))}
          />
          <Button
            onClick={handleResetDateFilter}
            sx={{
              fontSize: "0.6rem",
              padding: "5px 10px",
              backgroundColor: "#1c1948",
              color: "white",
              ml: "1rem",
              boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
              "&:hover": {
                color: "black",
                backgroundColor: "#11edd2",
              },
            }}
          >
            Reset date filter
          </Button>
        </Box>
        <Box>
          {error}
          <AdminTable data={data} loadingState={loading} />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            p: 2,
          }}
        >
          <Box>
            <Button
              onClick={handleOpenDialog}
              sx={{
                fontFamily: "Poppins",
                backgroundColor: "#1c1948",
                color: "white",
                fontSize: "14px",
                fontWeight: "bold",
                padding: "10px 20px",
                borderRadius: "5px",
                boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
                "&:hover": {
                  color: "black",
                  backgroundColor: "#11edd2",
                },
              }}
            >
              EXPORT REPORT
            </Button>

            {/* Dialog for selecting report type */}
            <Dialog
              open={open}
              onClose={handleCloseDialog}
              maxWidth="md"
              fullWidth
              sx={{
                "& .MuiDialog-paper": {
                  minWidth: "600px",
                  minHeight: "450px",
                  padding: "20px",
                },
              }}
            >
              <DialogTitle>GENERATE REPORT</DialogTitle>
              <DialogContent>
                <Select
                  value={reportType}
                  onChange={(e) => setReportType(e.target.value)}
                  fullWidth
                  sx={{ mb: 2 }}
                >
                  <MenuItem value="Quarterly">Quarterly Report</MenuItem>
                  <MenuItem value="Monthly">Monthly Report</MenuItem>
                  <MenuItem value="Annual">Annual Report</MenuItem>
                  <MenuItem value="Custom">Custom Report</MenuItem>
                </Select>

                {auth.role === "admin" && (
                  // <Select
                  //   value={selectedLocation}
                  //   onChange={(e) => setSelectedLocation(e.target.value)}
                  //   fullWidth
                  //   sx={{ mb: 2 }}
                  // >
                  //   <MenuItem value="SDO - Imus City">SDO - Imus City</MenuItem>
                  //   <MenuItem value="School - Imus City">
                  //     School - Imus City
                  //   </MenuItem>
                  // </Select>
                  <>
                    {console.log(
                      "Rendering Location, locations:",
                      selectedLocation
                    )}
                    <SelectDesignation
                      label="Select Location"
                      name="selectedLocation"
                      value={selectedLocation}
                      onChange={(name, value) => setSelectedLocation(value)}
                      sx={{ mt: 2, width: "100%" }}
                      hasData={selectedLocation}
                      // options={filteredOffices}
                      selectedLocation={selectedLocation}
                    />
                  </>
                )}

                {/* Office Selection (Only for Admin) */}
                {auth.role === "admin" && (
                  <>
                    {console.log(
                      "Rendering UnitSelect, designations:",
                      selectedOffice
                    )}
                    <UnitSelect
                      label="Select Office"
                      name="selectedOffice"
                      value={selectedOffice}
                      onChange={(name, value) => setSelectedOffice(value)}
                      sx={{ mt: 2, width: "100%" }}
                      hasData={setSelectedOffice}
                      designationId={selectedLocation}
                    />
                  </>
                )}
                {/* Year Selection for Monthly & Quarterly Reports */}
                {(reportType === "Monthly" || reportType === "Quarterly") && (
                  <Select
                    label="Report Type"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    fullWidth
                    sx={{ mt: 2 }}
                  >
                    {[...Array(10)].map((_, i) => {
                      const year = dayjs().year() - i;
                      return (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      );
                    })}
                  </Select>
                )}
                {/* Month Selection (Only for Monthly Report) */}
                {reportType === "Monthly" && selectedYear && (
                  <Select
                    value={selectedMonth || ""}
                    onChange={(e) => setSelectedMonth(e.target.value)}
                    fullWidth
                    sx={{ mt: 2 }}
                    displayEmpty
                  >
                    <MenuItem value="">All Months</MenuItem>
                    {[
                      "January",
                      "February",
                      "March",
                      "April",
                      "May",
                      "June",
                      "July",
                      "August",
                      "September",
                      "October",
                      "November",
                      "December",
                    ].map((month, index) => (
                      <MenuItem key={month} value={index + 1}>
                        {month}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {/* Year Selection for Annual Report */}
                {reportType === "Annual" && availableYears.length > 0 && (
                  <Select
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    fullWidth
                    sx={{ mt: 2 }}
                  >
                    {availableYears.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                {/* Date Range Pickers (Only for Custom Report) */}
                {reportType === "Custom" && (
                  <Box
                    sx={{
                      width: "100%",
                      mt: 3,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <DatePickerComponent
                      label="Start Date"
                      value={startDate}
                      onChange={(newValue) => setStartDate(dayjs(newValue))}
                    />
                    <DatePickerComponent
                      label="End Date"
                      value={endDate}
                      onChange={(newValue) => setEndDate(dayjs(newValue))}
                    />
                  </Box>
                )}
              </DialogContent>

              <DialogActions sx={{ gap: 2 }}>
                <Button onClick={handleCloseDialog} color="secondary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (reportType === "Quarterly" && selectedYear) {
                      handleQuarterlyReport(
                        selectedYear,
                        selectedLocation,
                        selectedOffice
                      );
                    } else if (reportType === "Monthly" && selectedYear) {
                      handleMonthlyReport(
                        selectedYear,
                        selectedMonth,
                        selectedLocation,
                        selectedOffice
                      );
                    } else if (reportType === "Annual" && selectedYear) {
                      handleYearlyReport(
                        selectedYear,
                        selectedLocation,
                        selectedOffice
                      );
                    } else if (
                      reportType === "Custom" &&
                      startDate &&
                      endDate
                    ) {
                      handleCustomReport(
                        startDate,
                        endDate,
                        selectedLocation,
                        selectedOffice
                      );
                    }
                  }}
                  color="primary"
                  disabled={
                    !reportType ||
                    ((reportType === "Quarterly" || reportType === "Monthly") &&
                      !selectedYear) ||
                    (reportType === "Custom" && (!startDate || !endDate))
                  }
                >
                  Generate Report
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
